import { render, staticRenderFns } from "./SuggestEventDialog.vue?vue&type=template&id=3fc1f03c&scoped=true&"
import script from "./SuggestEventDialog.vue?vue&type=script&lang=js&"
export * from "./SuggestEventDialog.vue?vue&type=script&lang=js&"
import style0 from "./SuggestEventDialog.vue?vue&type=style&index=0&id=3fc1f03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1f03c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VTextarea})
